export type BlobLike = {
  readonly arrayBuffer: () => Promise<ArrayBuffer>
  readonly arrayBufferSync: () => ArrayBuffer
  readonly createObjectURL: () => Promise<string>
  readonly size: number
  readonly slice: (start?: number, end?: number) => BlobLike
  readonly type: string
}

export type BlobArrayLike = {
  blobs: BlobLike[]
  clear: () => void
  offsets: number[]

  push: (inputs: BlobInput) => void
  size: number
  slice: (start?: number, end?: number) => BlobArrayLike
} & Omit<BlobLike, "size" | "slice">

export type BlobInputSimple = ArrayBuffer | Blob | string | Uint8Array

export type BlobInputSingle = BlobArrayLike | BlobInputSimple | BlobLike

export type BlobInput = BlobInputSingle | BlobInputSingle[]
